import React from "react";

function About() {
  return (
    <section id="about" className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-blue-900 mb-6">About Us</h2>
        <p className="text-gray-700 leading-relaxed">
        We are a family of immigrants from Ecuador, now proud to call Australia our home. Growing up near the Pacific coast, tuna was more than just food for us — it was part of our culture, our community, and our connection to the ocean.
        With De Galapagos, we bring that heritage and pride across the ocean, offering Australians the very best of Ecuador’s waters. De Galapagos is more than just a brand; it’s our way of sharing the richness of our then home with the people of our now home.
         Every tin carries a piece of Ecuador’s pristine seas, crafted for those who value quality, authenticity, and care for our planet.
        </p>
      </div>
    </section>
  );
}

export default About;
